<template>
  <div id="app" class="nby" :class="$route.name">
    <h-header class="visible-xs-block" v-if="!$route.meta.hideHeader && $route.meta.headerTitle" :is-fixed="$route.meta.headerFixed" :title="title"></h-header>
    <Progress class="container hidden-xs" v-if="$route.meta.index" :index="$route.meta.index"></Progress>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import Progress from './components/progress/progress.vue';
import { Header as hHeader } from 'hsb_recycle_components';

export default {
  name: 'App',
  data () {
    return {
      logo: require('./assets/logo.png'),
      slogan: 'slogan'
    };
  },
  components: {
    hHeader,
    Progress
  },
  computed: {
    theme () {
      return this.$store.state.config.theme;
    },
    title () {
      if (typeof this.$route.meta.headerTitle === 'function') {
        return this.$route.meta.headerTitle(this.$route, this.$store);
      }
      return this.$route.meta.headerTitle;
    }
  }
};
</script>

<style>
@import 'recover.css';

.view {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
}

.fade-enter-active, .fade-leave-active{
  transition: all .2s ease;
}

.fade-enter, .fade-leave-active{
  opacity: 0;
}

.nby {
  min-height: 100%;
  height: 100%;
}

</style>
